import {
    FilterColumnsArgs, GetColumnForNewFilterArgs,
} from '@mui/x-data-grid-pro'

export const filterColumns = ({
    field, columns, currentFilters,
}: FilterColumnsArgs) => {
    // remove already filtered fields from list of columns
    const filteredFields = currentFilters?.map((item) => { return item.field })
    const result = columns
        .filter(
            (colDef) => {
                return colDef.filterable
                    && (colDef.field === field || !filteredFields.includes(colDef.field))
            },
        )
        .map((column) => { return column.field })

    return result
}

export const getColumnForNewFilter = ({
    currentFilters,
    columns,
}: GetColumnForNewFilterArgs) => {
    const filteredFields = currentFilters?.map(({
        field,
    }) => { return field })
    const filters2 = columns
        .filter(
            (colDef) => { return colDef.filterable && !filteredFields.includes(colDef.field) },
        )
    const columnForNewFilter = filters2.find((colDef) => { return colDef.filterOperators?.length })

    return columnForNewFilter?.field ?? null
}
